import { SubAPI } from "./SubAPI";
export class ProjectNotes extends SubAPI {
    upsert(input) { return this.fetcher.post("/api/project-note", input); }
    list(props) { return this.fetcher.get("/api/project-notes", props); }
    listTags(props) { return this.fetcher.get("/api/project-note/tags", props); }
    upsertTag(input) { return this.fetcher.post("/api/project-note/tag", input); }
}
